import type { DataTableHeader } from '@/types/vuetify';

export function createUserBalancePageHeaders(): DataTableHeader[] {
    const { t } = useI18n();
    const company = t('userBalance.company');

    return [
        {
            title: t('userBalance.user'),
            value: 'login',
            key: 'login',
            align: 'start',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('userBalance.role'),
            value: 'toolUserTypeId',
            key: 'toolUserTypeId',
            align: 'center',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.betCount'),
            value: 'betCount',
            key: 'betCount',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('userBalance.bots'),
            value: 'settledBotCount',
            key: 'settledBotCount',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.turnover'),
            value: 'settledStakeSum',
            key: 'settledStakeSum',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.agTurnover'),
            value: 'settledStakeAgentSum',
            key: 'settledStakeAgentSum',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('userBalance.balance'),
            value: 'balance',
            key: 'balance',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.agBalance'),
            value: 'balanceAgentPc',
            key: 'balanceAgentPc',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('userBalance.agPayComms'),
            value: 'playerComEuro',
            key: 'playerComEuro',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('userBalance.agTotal'),
            value: 'agTotal',
            key: 'agTotal',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.bookTurnover'),
            value: 'settledStakeBookmakerSum',
            key: 'settledStakeBookmakerSum',
            align: 'end',
            sortable: false,
            nowrap: true,
            groupTitle: company,
        },
        {
            title: t('userBalance.comms'),
            value: 'companyComEuro',
            key: 'companyComEuro',
            align: 'end',
            sortable: false,
            nowrap: true,
            groupTitle: company,
        },
        {
            title: t('bookBalance.bookFees'),
            value: 'bookFeesEuro',
            key: 'bookFeesEuro',
            align: 'end',
            sortable: false,
            nowrap: true,
            groupTitle: company,
        },
        {
            title: t('userBalance.bookRebate'),
            value: 'bookRebateEuro',
            key: 'bookRebateEuro',
            align: 'end',
            sortable: false,
            nowrap: true,
            groupTitle: company,
        },
        {
            title: t('bookBalance.bookBalance'),
            value: 'balanceBookmakerPc',
            key: 'balanceBookmakerPc',
            align: 'end',
            sortable: false,
            nowrap: true,
            groupTitle: company,
        },
        {
            title: t('userBalance.ptBalance'),
            value: 'ptBalance',
            key: 'ptBalance',
            align: 'end',
            sortable: false,
            nowrap: true,
            groupTitle: company,
        },
        {
            title: t('userBalance.pl'),
            value: 'companyPlEuro',
            key: 'companyPlEuro',
            align: 'end',
            sortable: false,
            nowrap: true,
            groupTitle: company,
        },
    ];
}
